import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { translateRoomType } from '../../../constants/roomTypes';

const DeleteConfirmationModal = ({ 
  isOpen, 
  reservation, 
  onConfirm, 
  onClose, 
  isDeleting = false 
}) => {
  if (!isOpen || !reservation) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('pt-BR');
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(amount);
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg shadow-elevation-3 max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center space-x-3 p-6 border-b border-border">
          <div className="w-10 h-10 bg-destructive/10 rounded-lg flex items-center justify-center">
            <Icon name="AlertTriangle" size={20} color="var(--color-destructive)" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Confirmar Exclusão</h3>
            <p className="text-sm text-muted-foreground">Esta ação não pode ser desfeita</p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-6">
            <h4 className="font-medium text-foreground mb-3">Detalhes da Reserva:</h4>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Hóspede:</span>
                <span className="font-medium text-foreground">{reservation.guestName}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Email:</span>
                <span className="font-medium text-foreground">{reservation.guestEmail}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Quarto:</span>
                <span className="font-medium text-foreground">
                  {reservation.room?.number || reservation.roomNumber || 'N/A'} - {translateRoomType(reservation.room?.type || reservation.roomType) || 'N/A'}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Check-in:</span>
                <span className="font-medium text-foreground">{formatDate(reservation.checkInDate)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Check-out:</span>
                <span className="font-medium text-foreground">{formatDate(reservation.checkOutDate)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Valor:</span>
                <span className="font-medium text-foreground">{formatCurrency(reservation.totalAmount)}</span>
              </div>
            </div>
          </div>

          <div className="bg-destructive/5 border border-destructive/20 rounded-lg p-4 mb-6">
            <div className="flex items-start space-x-2">
              <Icon name="AlertTriangle" size={16} color="var(--color-destructive)" className="mt-0.5" />
              <div className="text-sm">
                <p className="font-medium text-destructive mb-1">⚠️ ATENÇÃO:</p>
                <ul className="text-destructive/80 space-y-1">
                  <li>• Esta ação NÃO pode ser desfeita</li>
                  <li>• O quarto será liberado para novas reservas</li>
                  <li>• Todos os dados da reserva serão perdidos</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
            iconName={isDeleting ? "Loader2" : "Trash2"}
            iconPosition="left"
          >
            {isDeleting ? 'Excluindo...' : 'Excluir Reserva'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
